/* eslint-disable no-const-assign */
/* eslint-disable no-loop-func */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { GridSortModelParams } from '@material-ui/data-grid';
import React, { useEffect, useState } from 'react';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { Redirect, useParams } from 'react-router';
import WarningIcon from "@material-ui/icons/Warning";
import { UserStateObject } from '../../interfaces/UserStateObject';
import './MassMessage.scss';
import UserContext from '../../utils/UserContext';
import { deleteScheduleMassiveEmail, getDetailScheduleMassiveEmail, getScheduledMassiveEmail } from '../../services/AdminServices';
import { isLogin } from '../../services/AuthService';

import { containsAny, sortByKey, sortByKeyDesc } from '../../helpers/sharedFunctions';
import MassMessageTable from './MassMessageTable';
import LoadingLockPage from '../ShareComponents/LoadingLockPage';
import { IScheduleMessage } from '../../interfaces/IScheduleMessage';
import ModalOffersAction from '../LaboralOffers/ModalOffersAction';
import SuccessModal from '../ShareComponents/SuccessModal';
import { permissionGraduateView } from '../../utils/PermissionsVariables';
import ErrorModal from '../ShareComponents/ErrorModal';
import NotAuthorized from '../ShareComponents/NotAuthorized/NotAuthorized';

export class UsersStateTosendObj {
    graduates: Array<UserStateObject> = []
}


const MassMessageScheduled: React.FC = () => {
    const { promiseInProgress } = usePromiseTracker();
    const [initLoad, setInitLoad] = useState<boolean>(true);
    const userContext = React.useContext(UserContext);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [initPage, setInitPage] = useState<number>(0);
    const [currrentPage, setCurrentPage] = useState<number>(0);
    const [dataFiltered, setDataFiltered] = useState<IScheduleMessage[]>([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [openModalSuccess, setOpenModalSuccess] = useState(false);
    const [openModalError, setOpenModalError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [updateReady, setUpdateReady] = useState<string>('');
    const [urlRedirect, setUrlRedirect] = useState<string>('');
    const limitNumber = 100;
    const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
    const [rowSelected, setRowSelected] = useState<IScheduleMessage>(new IScheduleMessage());
    let params: any = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
        const getInitialData = async () => {
            const getInfo: any = await getScheduledMassiveEmail(params.population, false);
            if (getInfo.status === 200) {
                let resultList: [IScheduleMessage] = (await getInfo.json()).schedules;
                const newList = resultList.filter(item => item !== null);
                resultList = sortByKeyDesc(newList, 'eventDate');
                setDataFiltered(resultList);
            }
            setInitLoad(false);
        }
        getInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSortedRows = (params: any) => {
        if (params.sortModel.length > 0) {
            let datasorted: IScheduleMessage[] = [...dataFiltered];
            datasorted.forEach(item => {
                if (item.ruleName) {
                    item.ruleName = (item.ruleName.charAt(0).toUpperCase() + item.ruleName.slice(1).toLowerCase()).trim();
                }
            });
            const fieldToSort = params.sortModel[0].field;
            const sortOption = params.sortModel[0].sort;
            if (sortOption === "asc") {
                datasorted = sortByKey(datasorted, fieldToSort);
            } else if (sortOption === "desc") {
                datasorted = sortByKeyDesc(datasorted, fieldToSort);
            }
            setDataFiltered(datasorted);
        }
    }

    const onChanhePageSize = (e: any) => {
        setRowsPerPage(e.target.value);
        setInitPage(0);
    }

    const handleCloseModalError = () => {
        setOpenModalError(false);
    };

    const handleUpdate = async (value: string, ruleName: string) => {

        let objectToSend: IScheduleMessage;
        const response: any = await trackPromise(getDetailScheduleMassiveEmail(ruleName))

        if (response.status === 200) {

            objectToSend = await response.json();            

            setOpenModalSuccess(true);
            setUrlRedirect(params.population === 'graduate' ?
                '/admin/dashboard/mensajeria-egresados' : '/admin/dashboard/mensajeria-empresas');
            setRowSelected(objectToSend)
            setUpdateReady(value)

        } else {
            setOpenModalError(true);
            setErrorMessage("Hubo un error, intente de nuevo mas tarde, o contacte al administrador general");
        }

    }

    const handleCloseModalSuccess = () => {
        setOpenModalSuccess(false);
        window.location.reload();
    };

    const deleteModal = (rowSelected: IScheduleMessage) => {
        setOpenDeleteModal(true);
        setRowSelected(rowSelected);
    }

    const closeModalDelete = () => {
        setOpenDeleteModal(false);
    }

    const deleteSchedule = async () => {
        closeModalDelete();

        const objectToSend = {
            "ruleName": rowSelected.ruleName,
        }

        const response: any = await trackPromise(deleteScheduleMassiveEmail(
            objectToSend
        ))

        if (response.status === 200) {
            setOpenModalSuccess(true);
            setSuccessMessage("Mensaje eliminado");
        } else {
            setOpenModalError(true);
            setErrorMessage("Hubo un error, intente de nuevo mas tarde, o contacte al administrador general");
        }
    }

    return (
        <>
            {isLogin() ?
                <>
                    {
                        containsAny(permissionGraduateView, userContext.userPermissions) ?
                            <>
                                {
                                    (updateReady.length > 0 && updateReady === "Edit") ?
                                        <Grid container >
                                            {
                                                <Redirect to={{ pathname: urlRedirect, state: { scheduledMessage: rowSelected } }} />
                                            }
                                        </Grid>
                                        :
                                        <>
                                            <Grid container className="main-container">
                                                <Grid container item xs={12}>
                                                    <Typography variant="h5" className="tab-description">
                                                        En esta interfaz puede administrar los mensajes programados.
                                                    </Typography>
                                                </Grid>

                                                <Grid container item xs={12}>
                                                    <Typography variant="h2" className="bold-serif-primaryColor">Mensajes programados</Typography>
                                                </Grid>
                                                <Grid container item xs={12}>
                                                    <MassMessageTable onChanhePageSize={onChanhePageSize} rows={dataFiltered} pageSize={rowsPerPage} initPage={initPage} setInitPage={setInitPage} onSortedRows={(params: GridSortModelParams) => handleSortedRows(params)} setCurrentPage={setCurrentPage} handleUpdate={handleUpdate} deleteModal={deleteModal} />
                                                </Grid>
                                            </Grid>
                                            <ErrorModal errorMsg={errorMessage} handleCloseModal={handleCloseModalError} openModalError={openModalError} />
                                            <SuccessModal successMsg={successMessage} handleCloseModal={handleCloseModalSuccess} openModalSuccess={openModalSuccess} />
                                            <ModalOffersAction
                                                open={openDeleteModal}
                                                handleClose={closeModalDelete}
                                                handleContinue={deleteSchedule}
                                                iconModal={<WarningIcon className="big-warning-icon" />}
                                                title="¿Está seguro de eliminar este mensaje programado?"
                                                headerdescription="Esta intentando eliminar el mensaje programado"
                                                description=""
                                                backBtnText="Regresar"
                                                colorBtnBack=""
                                                continueBtnText="Eliminar"
                                                colorBtnContinue="#f44336"
                                                valid={true}
                                            />
                                            <LoadingLockPage load={promiseInProgress} />
                                            <LoadingLockPage load={initLoad} />
                                        </>
                                }
                            </>
                            :
                            <NotAuthorized />
                    }
                </>
                :
                <Redirect to="/" />
            }
        </>
    )
}

export default MassMessageScheduled;